<!--
 * @Descripttion: 申请样品业务组件，支持快速申样及批量申样
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:15:33
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-22 17:01:06
-->
<template>
	<el-drawer title="修改详情" :visible.sync="visible" class="edit-rocend-drawer" :before-close="handleClose" size="600px" :wrapperClosable="false">
		<!-- 抽屉内容 -->
		<div class="content p-24">
			<el-table class="mt-24" :data="list" header-row-class-name="table-header-row" row-class-name="table-row" ref="table" v-loading="tableLoading">
				<el-table-column label="操作信息">
					<template slot-scope="{ row }">
						<div class="yx-color-text-primary font-h6-regular">
							<p>{{ row.opsUserName | formatEmpty }}</p>
							<p class="mt-6">{{ row.addTime | formatDateTime }}</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="修改前" width="150">
					<template slot-scope="{ row }">
						<div class="yx-color-text-primary font-h6-regular">
							<p>部门负责人：</p>
							<p>{{ row.originalLeaderName | formatEmpty }}</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="修改后" width="150">
					<template slot-scope="{ row }">
						<div class="yx-color-text-primary font-h6-regular">
							<p>部门负责人：</p>
							<p>{{ row.deptLeaderName | formatEmpty }}</p>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<yx-pagination
				:total="total"
				:current-page="pageInfo.pageNo"
				:page-size="pageInfo.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			/>
		</div>
		<!-- 底部按钮组 -->
		<div class="footer yx-background-white">
			<el-button @click="handleClose">关 闭</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { deptLeaderRecordList } from '@/api/teamManage';
export default {
	name: 'editRocendDrawer',

	data() {
		return {
			visible: false, // 抽屉显隐
			list: [],
			tableLoading: false,
			pageInfo: {
				pageNo: 1,
				pageSize: 10,
			},
			total: 0,
			deptId: '',
		};
	},
	methods: {
		show({ id }) {
			this.deptId = id;
			this.getList();
			this.visible = true;
		},
		async getList() {
			const { deptId } = this;
			this.tableLoading = true;
			try {
				const { list = [], total = 0 } = await deptLeaderRecordList({ deptId, ...this.pageInfo });
				this.list = list;
				this.tableLoading = false;
				this.total = total;
			} catch (e) {
				this.tableLoading = false;
			}
		},
		sizeChange(val) {
			this.pageInfo.pageSize = val;
			this.getList();
		},
		currentChange(val) {
			this.pageInfo.pageNo = val;
			this.getList();
		},
		handleClose() {
			this.pageInfo = {
				pageNo: 1,
				pageSize: 10,
			};
			this.total = 0;
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped>
.edit-rocend-drawer {
	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid #f0f1f5;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 999;
	}
}
</style>
